module.exports = __webpack_public_path__ + "img/attachment-clip.1ed549dc.svg";